import { apiRequest } from '../client';
import type { AdminDashboardResponse, AdminDrawListResponse, DashboardRoleFilter, DashboardStatusFilter } from '../../types/admin-dashboard';

export type DashboardQuery = {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: DashboardStatusFilter;
  role?: DashboardRoleFilter;
};

export const adminDashboardApi = {
  getDashboard: (query: DashboardQuery = {}) => {
    const params = new URLSearchParams();
    if (query.page) params.set('page', String(query.page));
    if (query.pageSize) params.set('pageSize', String(query.pageSize));
    if (query.search) params.set('search', query.search);
    if (query.status) params.set('status', query.status);
    if (query.role) params.set('role', query.role);
    const suffix = params.toString();
    return apiRequest<AdminDashboardResponse>(`/api/dashboard${suffix ? `?${suffix}` : ''}`);
  },
  getDraws: () => apiRequest<AdminDrawListResponse>('/api/draws'),
  loginAs: (accountId: string) => apiRequest<{ ok: true; role: string }>(`/api/accounts/${encodeURIComponent(accountId)}/login-as`, { method: 'POST' }),
};
